import { CustomNumberField } from "components/shared/form";
import VehicleOwnership from "components/shared/vehicleOwnership";
import { featureModuleTypesEnum } from "helpers/enums";
import { trailerNumber } from "helpers/validators";
import React from "react";

const Body = ({
    renderField,
    renderSelect,
    renderMechanic,
    renderFuelTanks,
    renderCheckbox,
    setValue,
    setCustomNumberMode,
    data,
    ...props
}) => {
    const {
        number,
        brandTypeId,
        loadUnloadOptions,
        typeId,
        carrying,
        volume,
        ownershipType,
        ownershipBasisDocuments,
        comment,
        transportColumnId,
        trackerId,
        isInRefuelingSyncList,
        availableFeatureModules,
        refuelingSettings,
        accessPermitIds,
        organizationName,
        ownershipDisabled,
    } = props;
    const useCustomNumber = !!data.useCustomNumber;

    return (
        <>
            <CustomNumberField
                number={number}
                numberValidator={trailerNumber}
                onCustomNumberChange={setCustomNumberMode}
                renderField={renderField}
                useCustomNumber={useCustomNumber}
            />
            {renderSelect(brandTypeId)}
            {renderSelect(typeId)}
            <VehicleOwnership
                carrying={carrying}
                data={data}
                disabled={ownershipDisabled}
                organizationName={organizationName}
                ownershipBasisDocuments={ownershipBasisDocuments}
                ownershipType={ownershipType}
                renderField={renderField}
                renderSelect={renderSelect}
                setValue={setValue}
                volume={volume}
            />
            {renderSelect({
                ...loadUnloadOptions,
                onChange: ({ name, value }) => setValue({ name, value: value.map((id) => ({ id })) }),
                value: data[loadUnloadOptions.inputProps.name].map((option) => option.id),
            })}
            {renderSelect(transportColumnId)}
            {renderMechanic()}
            {renderSelect(trackerId)}
            {renderField(comment)}
            {!refuelingSettings.hideRefuelingPlanning &&
                availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
                renderCheckbox(isInRefuelingSyncList)}
            {renderSelect(accessPermitIds)}
            {renderFuelTanks()}
        </>
    );
};

export default Body;
